import { Stack } from "react-bootstrap";
import { LI } from "../../AbstractElements";
import { Avatar } from "../../CommonElements/Avatar";
import { Fragment } from "react";
import {
  Alert01Icon,
  ArrowDown01Icon,
  Logout02Icon,
  UserIcon,
} from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useAuthContext } from "../../_helper/Auth";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../services/useAuth";
import { useScreenSize } from "../../utils/hooks/useScreenSize ";
import { useLocalizedText } from "../../utils/hooks/useLocalizedText";
import { getAvatarLetters } from "../../utils/helpers";
import { Dropdown, Space } from "antd";
import { Link } from "react-router";

export const Profile = () => {
  const { removeToken, user, removeUser } = useAuthContext();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { isMobile } = useScreenSize();
  const { getLocalizedText } = useLocalizedText();
  const handleLogout = () => {
    logout()
      .then((res) => {
        if (res?.status === 200) {
          removeToken();
          removeUser();
          window.location.href = `/login`;
        }
      })
      .catch((err) => console.log(err));
  };

  const items = [
    {
      label: (
        <Link to="/app/me" className="text-secondary">
          <Space align="center fw-bold">
            <HugeiconsIcon className="d-flex" size={18} icon={UserIcon} />
            <span>{t("PROFILE")}</span>
          </Space>
        </Link>
      ),
    },
    {
      label: (
        <Link to="/app/support" className="text-secondary">
          <Space align="center fw-bold">
            <HugeiconsIcon className="d-flex" size={18} icon={Alert01Icon} />
            {t("SUPPORT")}
          </Space>
        </Link>
      ),
    },
    {
      type: "divider",
    },
    {
      label: (
        <Space align="center fw-bold">
          <HugeiconsIcon className="d-flex" size={18} icon={Logout02Icon} />
          {t("LOGOUT")}
        </Space>
      ),
      onClick: handleLogout,
      danger: true,
    },
  ];
  return (
    <Fragment>
      <div className="vr"></div>

      <LI>
        <Dropdown menu={{ items }} trigger={["click"]}>
          <div
            role="button"
            id="PopoverLegacy"
            className="d-flex gap-2 align-items-center"
            tabIndex={1}
          >
            {!isMobile && (
              <div className="text-start">
                <Stack
                  direction="horizontal"
                  className="text-black fw-bold text-capitalize"
                >
                  <HugeiconsIcon size={18} icon={ArrowDown01Icon} />
                  <span className="btn-text-sm fw-bold">
                    {getLocalizedText(user?.name_ar, user?.name_en) || ""}
                  </span>
                </Stack>
                <div className="text-brand fw-bold text-end ">
                  {t(user?.type?.toUpperCase() ?? "")}
                </div>
              </div>
            )}
            <Avatar className="avatar border-0">
              {user?.profile_image_url ? (
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    margin: "0",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                  src={user.profile_image_url}
                  alt="profile"
                />
              ) : (
                getAvatarLetters(
                  getLocalizedText(user?.name_ar, user?.name_en)
                )?.toUpperCase()
              )}
            </Avatar>
          </div>
        </Dropdown>
      </LI>
    </Fragment>
  );
};
